const BASE_URL = process.env.REACT_APP_API_BASE_URL; // Use correct prefix

const API_ENDPOINTS = {
  PARENT_REGISTER: `${BASE_URL}${process.env.REACT_APP_PARENT_REGISTER}`,
  PARENT_LOGIN: `${BASE_URL}${process.env.REACT_APP_PARENT_LOGIN}`,
  PARENT_SEND_OTP: `${BASE_URL}${process.env.REACT_APP_PARENT_SEND_OTP}`,
  PARENT_VERIFY_OTP: `${BASE_URL}${process.env.REACT_APP_PARENT_VERIFY_OTP}`,
  BASIC_INFO: `${BASE_URL}${process.env.REACT_APP_BASIC_INFO}`,
  ADDRESS_INFO: `${BASE_URL}${process.env.REACT_APP_ADDRESS_INFO}`,
  ACADEMIC_INFO: `${BASE_URL}${process.env.REACT_APP_ACADEMIC_INFO}`,
  PARENT_INFO: `${BASE_URL}${process.env.REACT_APP_PARENT_INFO}`,
  FILE_UPLOAD: `${BASE_URL}${process.env.REACT_APP_FILE_UPLOAD}`,
  INITIATE_PAYMENT: `${BASE_URL}${process.env.REACT_APP_INITIATE_PAYMENT}`,
  SEND_PAYMENT_DATA: `${BASE_URL}${process.env.REACT_APP_SEND_PAYMENT_DATA}`,
  // FAILED_PAYMENT: `${BASE_URL}${process.env.REACT_APP_FAILED_PAYMENT}`,
  INITIATE_PENDING_PAYMENT: `${BASE_URL}${process.env.REACT_APP_INITIATE_PENDING_PAYMENT}`,
  DROPDOWN_DATA: `${BASE_URL}${process.env.REACT_APP_DROPDOWN_DATA}`,
  PARENT_DASHBOARD: `${BASE_URL}${process.env.REACT_APP_PARENT_DASHBOARD}`,
  STUDENT_DETAILS: `${BASE_URL}${process.env.REACT_APP_STUDENT_DETAILS}`,
  PARENT_LOGOUT: `${BASE_URL}${process.env.REACT_APP_PARENT_LOGOUT}`,

  // admin
  ADMIN_LOGIN: `${BASE_URL}${process.env.REACT_APP_ADMIN_LOGIN}`,
  ADMIN_DASHBOARD: `${BASE_URL}${process.env.REACT_APP_ADMIN_DASHBOARD}`,
  ADMIN_PASS_CHANGE: `${BASE_URL}${process.env.REACT_APP_ADMIN_PASS_CHANGE}`,
  ADMIN_PROFILE_UPDATE: `${BASE_URL}${process.env.REACT_APP_ADMIN_PROFILE_UPDATE}`,
  ADMIN_ADD_USER: `${BASE_URL}${process.env.REACT_APP_ADMIN_ADD_USER}`,
  ADMIN_LOGOUT: `${BASE_URL}${process.env.REACT_APP_ADMIN_LOGOUT}`,
  ADMIN_PARENT_DETAILS: `${BASE_URL}/admin/parent-details`,
  ADMIN_PARENT_PASS_CHANGE: `${BASE_URL}/admin/change-parent-password`,
  ADMIN_MANUAL_ADMISSION: `${BASE_URL}/admin/manual-admission`,



};

export default API_ENDPOINTS;
